import { AxiosError } from "axios";
import Button, { ButtonType } from "components/Elements/Buttonv2";
import Input from "components/Elements/Inputv2";
import Modal from "components/Elements/Modalv2";
import Progress from "components/Progress";
import React, { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ApiService from "services/api.service";
import { Workflow } from "types/Workflow";

interface NameWorkflowModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const NameWorkflowModal: FC<NameWorkflowModalProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [flowName, setFlowName] = useState("");

  const createWorkflow = async () => {
    setIsLoading(true);
    try {
      const { data } = await ApiService.post<Workflow>({
        url: "/workflows",
        options: { name: flowName },
      });
      navigate("/flow/" + data.id);
    } catch (err) {
      let message = "Unexpected error";
      if (err instanceof AxiosError) message = err.response?.data.message;
      toast.error(message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      {isLoading ? (
        <div className="flex items-center justify-center py-6">
          <Progress />
        </div>
      ) : (
        <div className="flex flex-col gap-5">
          <div className="text-[18px] font-semibold leading-[26px]">
            Create workflow
          </div>

          <div className="flex flex-col gap-1.5">
            <div className="text-[13px] font-medium text-themed-text">
              Workflow name
            </div>
            <Input
              value={flowName}
              onChange={setFlowName}
              placeholder="Workflow name"
              id="workflow-name-input"
              wrapperClassName="!max-w-full w-full"
              className="w-full"
            />
          </div>

          <div className="flex justify-end gap-2">
            <Button type={ButtonType.SECONDARY} onClick={onClose}>
              Cancel
            </Button>
            <Button
              type={ButtonType.PRIMARY}
              onClick={createWorkflow}
              disabled={!flowName.trim()}
              id="create-workflow-modal-button"
            >
              Create workflow
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default NameWorkflowModal;
